import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { MembershipReportExportContainerModel } from "../../../../../../models/aggregates/crm/membership/membership-report-export-container.model";

@Injectable({ providedIn: "root" })
export class MembershipReportExportService extends BaseApiTemplateService<MembershipReportExportContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + "membership-report-file-hdrs/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + "membership-report-file-hdrs/backoffice-ep";
    this.httpClient = http;
  }
}
